import SelfServeBuilderToolboxConstants from './SelfServeBuilderToolboxConstants';

export const hideTooltips = () => (
  (dispatch) => {
    dispatch({
      type: SelfServeBuilderToolboxConstants.TOOLTIPS_HIDE,
    });
  }
);

export const setActiveToolboxToolItem = toolType => (
  (dispatch) => {
    dispatch({
      type: SelfServeBuilderToolboxConstants.ACTIVE_TOOLBOX_ITEM_SET,
      toolType,
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderToolbox/SelfServeBuilderToolboxActions.jsx